import styled from 'styled-components';
import { AlignCenter } from '../../global/commonStyle';
import { Typography } from '../../global/theme';

export const ColorPickerWrapper = styled.div`
  width: 240px;
  padding: var(--space-16);
  background: var(--background-primary);
  border-radius: var(--border-radius-16);
  box-shadow: var(--shadow-dropdown);
  border: 0.5px solid var(--border-primary);
`;

export const ColorArea = styled.div<{ hue: number }>`
  position: relative;
  width: 100%;
  height: 150px;
  margin-bottom: var(--space-12);
  background: ${(props) => `hsl(${props.hue}, 100%, 50%)`};
  cursor: crosshair;
  border-radius: var(--border-radius-8);

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  &::before {
    background: linear-gradient(to right, var(--text-white), transparent);
    border-radius: var(--border-radius-8);
  }

  &::after {
    background: linear-gradient(to bottom, transparent, #000);
    border-radius: var(--border-radius-8);
  }
`;

export const ColorThumb = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;
  border: 2px solid white;
  border-radius: var(--border-radius-full);
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: var(--z-index-base);
  box-shadow: var(--border-outset);
`;

export const SpectrumSlider = styled.div`
  position: relative;
  width: 100%;
  height: 12px;
  margin-bottom: var(--space-12);
  background: linear-gradient(
    to right,
    #ff0000 0%,
    #ffff00 17%,
    #00ff00 33%,
    #00ffff 50%,
    #0000ff 67%,
    #ff00ff 83%,
    #ff0000 100%
  );
  border-radius: var(--border-radius-6);
  cursor: pointer;
`;

export const SpectrumThumb = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;
  background: var(--text-white);
  border-radius: var(--border-radius-full);
  transform: translateX(-50%);
  box-shadow: var(--border-outset);
  pointer-events: none;
`;

export const ColorInputWrapper = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  .input-field {
    div,
    input {
      background-color: var(--background-tertiary);
    }
  }
`;

export const InputLabel = styled.span`
  ${Typography.body_lg}
  color: var(--text-secondary);
`;
